import { apiDelete } from "../baseApi";

export const deleteRejectedUserById = async (id,data={}, cancelToken = null) => {
  try {
    const response = await apiDelete("_domainUserRejected", id, data, { cancelToken });
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
